const NotFound = () => {
    return ( 
        <div classname='not-found'> 
            <h2>Sorry!</h2>
            <p>Page cannot be found</p>
            <link to='/'>Back to the homepage...</link>
        </div>
     );
}
 
export default NotFound
